<template>
  <div class="programmes-wrap">
    <!-- {{ugProgrammes}} -->
    <div class="block" v-if="!loading">

      <!-- <input v-model="searchTerm" type="text"> -->
      <!-- {{filteredProgrammes}} -->
      <search-filter 
        :searchTerm.sync="searchTerm"
        />

        <div v-if="filteredProgrammes.length === 0">
          <p>No results found for <strong>{{searchTerm}}</strong>, <a href="/study/programmes-courses/subjects">search our subjects.</a></p>
        </div>
    
    
      <ugprogramme 
        v-for="prog in filteredProgrammes"
        :key="prog.name"
        :prog="prog"
      />
    </div>
    <div v-else>
      <p>Loading degrees...</p>
    </div>
  </div>
</template>

<script>
  import ugprogramme from './UGProgramme.vue'
  import searchFilter from './SearchFilter.vue'
  
  export default {
    name: 'UgProgrammes',
    props: ['ugProgrammes', 'loading'],
    components: {
      ugprogramme,
      searchFilter
    },
    data () {
      return {
        searchTerm: ''
      }
    },
    computed: {
      filteredProgrammes () {
        let filteredProgs = this.ugProgrammes.filter( ( prog ) => {
          return prog.name.toLowerCase().includes( this.searchTerm.toLowerCase() );
        } )
        // let orderedStories = filteredStories.sort( ( a, b ) => {
        //   return b.upvoted - a.upvoted;
        // } )
        // return orderedStories;
        let alphabetisedProgs = filteredProgs.sort( ( a, b ) => {
          return a.name.localeCompare(b.name)
        }) 
        return alphabetisedProgs
        // return filteredProgs;
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>